import { lazy, Suspense, useEffect } from 'react'

import { LoadingTurbo } from 'atoms'

import { OrganizationScreenComponent } from './OrganizationScreen.types'
import { useOrganizationScreen } from './useOrganizationScreen'

const OrganizationScreenMobile = lazy(() => import('./OrganizationScreen.mobile'))

export const OrganizationScreen: OrganizationScreenComponent = ({ navigation, route }) => {
  const organizationScreen = useOrganizationScreen({ navigation, route })

  const tabId = route?.params?.tabId ?? 2

  useEffect(() => {
    if (Number(tabId) === 2) {
      navigation.navigate('OpportunitiesList')
    }
  }, [navigation, tabId])

  if (Number(tabId) === 2) {
    return <LoadingTurbo />
  }

  const Screen = OrganizationScreenMobile

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <Screen {...organizationScreen} />
    </Suspense>
  )
}
